var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-error-guard',{attrs:{"error-mode":_vm.errorMode},scopedSlots:_vm._u([{key:"error",fn:function(ref){
var reset = ref.reset;
return [_c('auth-error',{attrs:{"on-reset":reset}})]}}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }